/* eslint-disable */

import axios from "axios";
require("../../config/development");
import Vue from "vue";

import moment from "moment";

const state = {
  userSignatureData: null,
  copyUserSignatureData: null,
  signaturePendingList: [],
  signatureData: [],
  signatureStatus: null,
  loading: false,
  fileUrl: null,
  pdf: null,
  cancelChanges: false,
  croppedImgUrl: null,
  sortByCreatedDate:null,
  sortByUpdatedDate:null,
  tabs: [
    {
      name: "Personal",
      checkDetails: {
        pan_status: true,
        name: true,
        dob: true,
        signature: true
      },
      isReject: false
    },
    { name: "Approve", isReject: true }
  ]
};
const self = Vue.app;
// getters
const getters = {
  getSignatureDetails: state => {
    return state.userSignatureData;
  },
  getSignatureDetailsById: state => id => {
    return state.signatureData.find(element => element.id === id);
  },

  getFilterSignatureInfoByStatus: state => status => {
    return state.signatureData.filter(
      element => element.kyc_form_check_status === status
    );
  }
};

// actions
const actions = {
  fetchSignatureData(context, payload) {
    let api = '';
    if(payload == 'submitted') {
      api = 'submitted_kyc_details'
    } else if(payload == 'rejected') {
      api = 'rejected_kyc_details'
    } else {
      api = 'unverified_kyc_details'
    }

    let admin_partner = context.rootGetters.admin_partner
    let end_point = Vue.config.EL_DORADO_API_URL
    if (admin_partner == "az"){
      end_point = Vue.config.EL_DORADO_API_URL_BIGCO
    }
    context.commit("toggleLoading", true);
    return axios
      .get(
        `${end_point}/admin/adfes433fkdfggs343434/signatures.json`
      )
      .then(response => {
        console.log("signatureVerification pending users list", response.data)
        let data = {
          id: "",
          name: "",
          PAN_number: "",
          createdAt: "",
          updatedAt: "",
          email: ""
        }
        context.commit("saveDetailsSignature", response);
        context.commit("toggleLoading", false);
      })
      .catch(function(err) {
        context.commit("toggleLoading", false);

        return new Promise((resolve, reject) => reject());
      });
  },
  async signatureDetailsByID(context, id) {
    let admin_partner = context.rootGetters.admin_partner
    let end_point = Vue.config.EL_DORADO_API_URL
    if (admin_partner == "az"){
      end_point = Vue.config.EL_DORADO_API_URL_BIGCO
    }

    return axios
      .get(
        `${end_point}/admin/adfes433fkdfggs343434/signatures/${id}.json`
      )
      .then(response => {
        context.commit("SHOW_NOTIFICATION", {
          showNotification: true,
          message: "Data is loaded successfully",
          succesFlag: true
        });
        // context.commit("setNotifyFlag", true);
        context.commit("saveUserSignatureData", response.data);
        context.commit("saveCopyUserSignatureData", response.data);
        return response;
      })
      .catch(function() {
        context.commit("SHOW_NOTIFICATION", {
          showNotification: true,
          message: "Error in fetching data..",
          succesFlag: false
        });
      });
  },

  signfetchPdf(context, payload) {
    try{
      let admin_partner = context.rootGetters.admin_partner
      let end_point = Vue.config.EL_DORADO_API_URL
      if (admin_partner == "az"){
          end_point = Vue.config.EL_DORADO_API_URL_BIGCO
        }          
        context.commit("SHOW_NOTIFICATION", {
          showNotification: true,
          message: "PDF is loaded successfully",
          succesFlag: true
        });
        let redirect_uri =
          end_point +
          `/admin/adfes433fkdfggs343434/ipv/${payload.id}/${payload.key}.pdf?auth_token=${Vue.vueAuth.getToken()}`;
        window.open(redirect_uri, "_blank");
        context.commit("savePDFUrl", redirect_uri);
      } catch(err) {
        console.log("err in pdf",err)
        context.commit("SHOW_NOTIFICATION", {
          showNotification: true,
          message: "Error in loading pdf..",
          succesFlag: false
        })
      };
  },

  getUrlToken(context) {
    let admin_partner = context.rootGetters.admin_partner
    let end_point = Vue.config.EL_DORADO_API_URL
    if (admin_partner == "az"){
      end_point = Vue.config.EL_DORADO_API_URL_BIGCO
    }   
    return axios
      .get(`${end_point}//api/v3/user/get_token.json`)
      .then(response => new Promise((resolve, reject) => resolve(response)))
      .catch(err => new Promise((resolve, reject) => reject(err)));
  },
  uploadFile(context, payload) {
    let admin_partner = context.rootGetters.admin_partner
    let end_point = Vue.config.EL_DORADO_API_URL
    if (admin_partner == "az"){
      end_point = Vue.config.EL_DORADO_API_URL_BIGCO
    }      
    let formdata = new FormData();
    formdata.append("attachment", payload.file);
    formdata.append("type", payload.file.type);
    axios
      .put(`${end_point}/admin/adfes433fkdfggs343434/upload/file.json`, formdata)
      .then(response => {
        context.commit("SHOW_NOTIFICATION", {
          showNotification: true,
          message: "Successfully upload pdf..",
          succesFlag: true
        });
        let cvl = {
          status: "",
          remarks: "",
          cvl_audit: {
            personal: {
              pan_status: "",
              name: ""
            },
            ipv: {
              gender: "",
              video: ""
            },
            address: {
              address_status: ""
            },
            kyc: {}
          }
        };
        if (
          payload.key == "file_signature" ||
          payload.key === "file_kyc_form"
        ) {
          if (payload.key === "file_kyc_form")
            context.commit("saveFileURL", response.data.file_url);
          cvl.cvl_audit.kyc[payload.key] = response.data.file_url;
        } else {
          cvl.cvl_audit.ipv[payload.key] = response.data.file_url;
        }

        context.dispatch("submitSignatureQuery", { data: cvl, id: payload.id });
        context.commit("updateSignatureDetail", payload);
      })
      .catch(() =>
        context.commit("SHOW_NOTIFICATION", {
          showNotification: true,
          message: "Error in uploading pdf..",
          succesFlag: false
        })
      );
  },
  async uploadImage(context,payload){
    let obj = {name: payload.name,image: payload.image,type:payload.key}
    let admin_partner = context.rootGetters.admin_partner
    let end_point = Vue.config.EL_DORADO_API_URL
    if (admin_partner == "az"){
      end_point = Vue.config.EL_DORADO_API_URL_BIGCO
    }       
    return axios
    .put(`${end_point}/admin/adfes433fkdfggs343434/upload/image.json`, obj)
    .then(response => {
      context.commit("SHOW_NOTIFICATION", {
        showNotification: true,
        message: "Successfully upload image..",
        succesFlag: true
      });
      let cvl = {
        status: "",
        remarks: "",
        cvl_audit: {
          personal: {
            pan_status: "",
            name: ""
          },
          ipv: {
            gender: "",
            video: ""
          },
          address: {
            address_status: ""
          },
          kyc: {}
        }
      };
      if (
        payload.key == "file_signature" ||
        payload.key === "file_kyc_form"
      ) {
        if (payload.key === "file_kyc_form")
          context.commit("saveFileURL", response.data.file_url);
        cvl.cvl_audit.kyc[payload.key] = response.data.file_url;
      } else {
        cvl.cvl_audit.ipv[payload.key] = response.data.file_url;
      }

      context.dispatch("submitSignatureQuery", { data: cvl, id: payload.id });
      context.commit("updateSignatureDetail", payload);
      console.log(response,'inupload')
      return response;
    })
    .catch(() =>
      context.commit("SHOW_NOTIFICATION", {
        showNotification: true,
        message: "Error in uploading image..",
        succesFlag: false
      })
    );
  },
  updateSignatureDetail(context, payload) {
    let obj = {};
    let signatureData = payload.data;
    let cvl = {
      status: "",
      remarks: "",
      cvl_audit: {
        personal: {
          pan_status: "",
          name: ""
        },
        ipv: {
          gender: "",
          video: ""
        },
        address: {
          address_status: ""
        },
        kyc: signatureData
      }
    };
    obj.data = cvl;
    obj.id = payload.id;
    context
      .dispatch("submitSignatureQuery", obj)
      .then(() =>
        context.commit("SHOW_NOTIFICATION", {
          showNotification: true,
          message: "Successfully update IpvInfo..",
          succesFlag: true
        })
      )
      .catch(() =>
        context.commit("SHOW_NOTIFICATION", {
          showNotification: true,
          message: "Error while updating IpvInfo..",
          succesFlag: false
        })
      );
  },
  submitSignatureQuery(context, payload) {
    console.log({submitdata:payload})
    let data = { signature: payload.data };
    let admin_partner = context.rootGetters.admin_partner
    let end_point = Vue.config.EL_DORADO_API_URL
    if (admin_partner == "az"){
      end_point = Vue.config.EL_DORADO_API_URL_BIGCO
    }      
    return axios
      .put(
        `${end_point}/admin/adfes433fkdfggs343434/signatures/${payload.id}.json`,
        data
      )
      .then(response => {
        Promise.resolve(response);
      })
      .catch(err => Promise.reject(err));
  }
};

// mutations
const mutations = {
  saveSignaturePendingUsers(state, payload) {
    console.log("payload", payload)
    state.signaturePendingList = payload.data.data;
  },
  saveUserSignatureData(state, payload) {
    state.userSignatureData = payload;
  },
  saveCopyUserSignatureData(state, payload) {
    let data = JSON.parse(JSON.stringify(state.userSignatureData));

    state.copyUserSignatureData = data;
  },
  saveDetailsSignature(state, payload) {
    console.log("payload", payload)
    state.signatureData = payload.data.data;
  },
  toggleLoading(state, flag) {
    state.loading = flag;
  },

  saveFileURL(state, payload) {
    state.fileUrl = payload;
  },
  savePDFUrl(state, payload) {
    state.pdf = payload;
  },

  updateSignatureDetail(state, payload) {
    state.userSignatureData[payload.key] = payload.value;
  },

  setSignatureStatus(state, payload) {
    state.signatureStatus = payload;
  },
  cancelChanges(state) {
    let data = JSON.parse(JSON.stringify(state.copyUserSignatureData));
    console.log(data)
    state.userSignatureData = data;
  },
  removeUserDetails(state) {
    state.userSignatureData = null;
    state.copyUserSignatureData = null;
  },
  setcroppedImgUrl(state, payload) {
    state.croppedImgUrl = payload;
  },
  setSortingByDate(state,payload){
    let data = Object.keys(payload)[0];
    state[data] = payload[data];
  },
  toggleRejectSignature(state,payload){
    state.tabs[payload.index].isReject = payload.value;
  },
  toggleCheckBoxSignature(state,payload){
    state.tabs[payload.index].checkDetails[payload.element] = payload.value
  },
  resetSignatureTab(state){
    state.tabs = [
      {
        name: "Personal",
        checkDetails: {
          pan_status: true,
          name: true,
          dob: true,
          signature: false
        },
        isReject: true
      },
      { name: "Approve", isReject: true }
    ]
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
